import SEO from './index.json';

export default SEO;
